import { useEffect, useRef } from "react";
// import { Editor } from "@tinymce/tinymce-react";
import styled from "styled-components";
import { isExcelFile, isImageFile, isPdfFile, isWordFile } from "../../utils/fileUtils";
import { axiosInstance } from "../../utils/axiosInstance";
import { NEWS_API_ENDPOINTS } from "../../context/NewsContext/constants";

type EntityEncoding = "named" | "numeric" | "raw";


// const tinyMceConfig = {
// 	menubar: "",
// 	language: "tr_TR",
// 	language_url: "/langs/tr.js",
// 	entity_encoding: "raw" as EntityEncoding,
// 	promotion: false,
// 	branding: false,
// 	plugins: "link",
// 	toolbar: "bold italic underline | link",
// 	paste_as_text: true,
// 	file_picker_types: "file image media",
// 	file_picker_callback: async (callback: any) => {
// 		const input = document.createElement("input");
// 		input.setAttribute("type", "file");

// 		input.onchange = async () => {
// 			const file = input.files?.[0];
// 			if (file) {
// 				const formData = new FormData();
// 				formData.append('file', file);

// 				try {
// 					const response = await axiosInstance.post(NEWS_API_ENDPOINTS.ADD_NEWS_FILE, formData, {
// 						headers: {
// 							'Content-Type': 'multipart/form-data',
// 						},
// 					});

// 					const fileUrl = response.data.result.item;

// 					if (isPdfFile(file.type)) {
// 						callback(fileUrl, {
// 							title: file.name,
// 							text: `<a href="${fileUrl}" target="_blank">${file.name}</a>`
// 						});
// 					} else if (isImageFile(file.type)) {
// 						callback(fileUrl, { title: file.name });
// 					} else if (isWordFile(file.type) || isExcelFile(file.type)) {
// 						callback(fileUrl, {
// 							title: file.name,
// 							text: `<a href="${fileUrl}" download>${file.name}</a>`
// 						});
// 					} else {
// 						callback(fileUrl, {
// 							title: file.name,
// 							text: `<a href="${fileUrl}" download>${file.name}</a>`
// 						});
// 					}
// 				} catch (error) {
// 					console.error('Error uploading the file:', error);
// 				}
// 			}
// 		};
// 		input.click();
// 	},
// };

interface RichTextComponentProps {
	messageTemplate?: string;
	handleSetChangedTemplate: (body: string) => void;
	backgroundColor?: string;
}

const StyledEditor = styled.div<{ backgroundColor?: string }>`
	.tox-statusbar__path-item {
		display: none !important;
	}
	
	.tox-edit-area iframe {
		background-color: ${(props) => props.backgroundColor || '#424242'};
	}
`;

const RichTextComponent = ({ messageTemplate, handleSetChangedTemplate, backgroundColor }: RichTextComponentProps) => {
	const editorRef = useRef<any>(null);

	const handleEditorChange = () => {
		if (editorRef.current) {
			handleSetChangedTemplate(editorRef.current.getContent());
		} else {
			if (messageTemplate)
				handleSetChangedTemplate(messageTemplate);
		}
	};

	useEffect(() => {
		if (messageTemplate)
			handleSetChangedTemplate(messageTemplate);
	}, [messageTemplate, handleSetChangedTemplate]);

	return (
		<StyledEditor backgroundColor={backgroundColor}>
			{/* <Editor
				onInit={(evt, editor) => (editorRef.current = editor)}
				init={{
					...tinyMceConfig,
					setup: (editor) => {
						editor.on("Change", handleEditorChange);
					},
				}}
				initialValue={messageTemplate}			
			/> */}
		</StyledEditor>
	);
};

export default RichTextComponent;
